import { Component, ViewEncapsulation } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MobileCheckServiceService } from 'app/services/mobile-check-service.service';

@Component({
  selector: 'app-return-back-page',
  templateUrl: './return-back-page.component.html',
  styleUrls: [],
  encapsulation: ViewEncapsulation.None
})
export class ReturnBackPageComponent {

  constructor(private location: Location, private router: Router, 
    private mobileCheck: MobileCheckServiceService) { }

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back(); // Navigate back if history exists
    } else {
      this.router.navigate(['/']); // Navigate to some default route
    }
  }


  get mobile(): boolean {
    return this.mobileCheck.mobile;
  }
}
